import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';

// Context
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';

// Routes
import AppRoutes from './routes';

/**
 * Composant principal de l'application
 * Configure les providers et le routing
 */
const App = () => {
  // Récupérer le Google Client ID depuis les variables d'environnement
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

  return (
    <BrowserRouter>
      <GoogleOAuthProvider clientId={googleClientId}>
        <LanguageProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </LanguageProvider>
      </GoogleOAuthProvider>
    </BrowserRouter>
  );
};

export default App;
